module.exports = __webpack_public_path__ + "pencil-edit-button.png?72aad6c8b6f90c32cfb952e23e7e6ada";


//////////////////
// WEBPACK FOOTER
// ./Content/img/pencil-edit-button.png
// module id = 31
// module chunks = 1